const indexItems = [
  { title: '热播电视剧', desc: '最新上线的热门国产剧、海外剧全集', icon: 'ri-tv-line', color: 'bg-primary-500/15 text-primary-400' },
  { title: '电影大全', desc: '院线大片、经典老片、小众文艺俱全', icon: 'ri-film-line', color: 'bg-accent-500/15 text-accent-400' },
  { title: '综艺节目', desc: '热门综艺完整版，搞笑竞技应有尽有', icon: 'ri-emotion-laugh-line', color: 'bg-secondary-500/15 text-secondary-400' },
  { title: '动漫番剧', desc: '日漫国漫同步更新，二次元爱好者天堂', icon: 'ri-ghost-line', color: 'bg-primary-500/15 text-primary-400' },
  { title: '纪录片', desc: '自然人文历史，拓宽视野的高品质内容', icon: 'ri-earth-line', color: 'bg-accent-500/15 text-accent-400' },
  { title: '4K专区', desc: '超高清画质体验，最佳观影效果呈现', icon: 'ri-4k-line', color: 'bg-secondary-500/15 text-secondary-400' },
  { title: '经典修复', desc: '老片焕新，经典影视作品4K高清修复', icon: 'ri-restart-line', color: 'bg-primary-500/15 text-primary-400' },
];

export default function IndexSection() {
  return (
    <section id="index" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">专题合集</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">按分类探索海量片库，快速找到想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-start gap-4 bg-background-100 rounded-xl p-5 border border-background-200/50 hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <span className={`flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-foreground-100 font-semibold text-sm md:text-base mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
              <span className="flex-shrink-0 flex items-center self-center text-foreground-700 group-hover:text-primary-400 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}